import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ProfilePage } from './profilepage/profilepage';
import { ContactPage } from './profilepage/contactpage';
import './css/styles.css';

export function loader() {
  return Response.json({ version: "52" });
}

export function App() {
  return (
    <div className="App">
        <Router>
          <Routes>
            <Route path='/' element={<ProfilePage/>} />
            <Route path="/contact" element={<ContactPage/>}/>
          </Routes>
        </Router>
      </div>
  );
}
